import React from 'react';

class SuccessMsg extends React.Component {

    constructor() {
        super();
        this.fechar = this.fechar.bind(this);
    }

    fechar() {
        this.props.fechar();
    }

    render() {
        return (
            <div id="dashboard-success-msg">
                <p id="dashboard-success-msg-fechar-btn" onClick={ this.fechar }>
                    Fechar
                </p>
                <p id="dashboard-success-msg-txt">
                    { this.props.msg }
                </p>
            </div>
        );
    }

}

export default SuccessMsg;

